<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <!-- 选择门店 -->
          <el-form-item label="">
            <el-select
              v-model="queryForm.branchId"
              clearable
              placeholder="请选择门店"
              class="pr-10"
            >
              <el-option
                v-for="item in branchList"
                :key="item.branchId"
                :label="item.title"
                :value="item.branchId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              class="pr-10"
              clearable
              placeholder="关键词(搜索标题，详情等)"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="所属门店"
        prop="branch.title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="微信分账单号"
        prop="basic.shareOrderNo"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="订单号"
        prop="basic.orderNo"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="收款方"
        prop="receiver.title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="订单金额"
        prop="basic.orderAmount"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="分账金额"
        prop="basic.amount"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ filterPrice(row.basic.amount) }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="微信支付单号"
        prop="basic.transactionId"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="状态"
        prop="basic.address"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          <el-tag type="warning" v-if="row.step === 1">待分账</el-tag>
          <el-tag type="success" v-if="row.step === 2">分账成功</el-tag>
          <el-tag type="danger" v-if="row.step === 3">分账失败</el-tag>
          <el-tag type="info" v-if="row.step === 4">已关闭</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="100px"
      >
        <template #default="{ row }">
          <el-button v-if="row.step == 3" type="text" class="mr-10" @click="handleFix(row)">
            手动分账
          </el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <detail ref="show" />
  </div>
</template>

<script>
import moment from 'moment'
import { findRecordList, fixRecord } from '@/api/splitAccount'
import { getAllBranchs } from '@/api/branch'
import { filterPrice } from '@/utils/tool'
import Detail from './detail.vue'
export default {
  name: 'SplitRecord',
  components: { Detail },
  data() {
    return {
      moment,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      branchList: [],
      queryForm: {
        page: 1,
        size: 10,
        keyword: '',
        branchId: '',
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/splitAccount/splitRecord') {
        this.fetchData()
        this.findBranchAll()
      }
    },
  },
  created() {
    this.fetchData()
    this.findBranchAll()
  },
  methods: {
    filterPrice,
    //获取fen店列表
    async findBranchAll() {
      const res = await getAllBranchs()
      this.branchList = res || []
    },
    async handleFix(row) {
      this.$baseConfirm(
        `你确定要手工分账方吗，订单号：${row.basic.orderNo}，分账金额：${row.basic.amount.toFixed(2)}`,
        null,
        async () => {
          const ret = await fixRecord({
            recordId: row.recordId,
          })
          if(ret){
            this.$baseMessage(
              `分账提交成功`,
              'success',
              false,
              'vab-hey-message-success'
            )
            this.fetchData()
          }
        }
      )
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await findRecordList(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.big-avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
